import React, { Component } from 'react'
import { Container, Button, Toolbar, SearchField, Label, CheckBoxField, RadioField, ContainerField } from '@sencha/ext-modern'
import Message from '../../components/Message'
import { WX } from '../../public'

Ext.require([
  'Ext.dataview.listswiper.ListSwiper',
  'Ext.MessageBox'
])

const style = {
  outer: {
    backgroundColor: "#f5f5f5",
    paddingTop: "10px",
    paddingRight: "10px",
    paddingLeft: "20px",
    paddingBottom: "10px"
  },
}

class OrderingDetail extends Component {
  state = {
    errorMessage: null,
    type: '附件上传',
  }

  componentDidMount() {
    const { match: { params: { date } } } = this.props
    const dateValue = new Date(date)
    Tyan.doPostEvent('WXGetMealOrderRecord', {
      data: { date: dateValue.valueOf() },
      onEnd: ({ errorMessage, MealOrderStatus, bSave }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        } else {
          this.setState({ MealOrderStatus, bSave })
        }
      },
    })
  }

  onSave = () => {
    const { MealOrderStatus } = this.state
    const { match: { params: { date } } } = this.props
    const dateValue = new Date(date)
    Tyan.doPostEvent('WXSaveMealOrderRecord', {
      data: { date: dateValue.valueOf(), MealOrderStatus },
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        } else {
          Ext.toast('保存成功')
          this.onBack()
        }
      },
    })
  }

  onBack = () => {
    this.props.history.goBack()
  }

  handleChange = ({ name, _boxLabel }) => {
    this.setState({ [name]: _boxLabel })
  }

  render() {
    const { errorMessage, MealOrderStatus, bSave } = this.state
    if (errorMessage) {
      return <Message text="数据加载失败" subText={errorMessage} />
    }
    const { match: { params: { date } } } = this.props
    const dateValue = new Date(date)
    return (
      <Container layout={{ type: "vbox" }} style={style.outer} scrollable >
        <Toolbar shadow={false} docked="top" padding="0" margin="0">
          <Container layout={{ type: "vbox", align: 'left' }}>
            <ContainerField layout={{ type: 'hbox', pack: 'start', wrap: true }} style={{ padding: 0, fontSize: '18px' }} >
              <Label html={`${dateValue.getFullYear()}年${dateValue.getMonth() + 1}月${dateValue.getDate()}日`} style={{ fontSize: '20px', padding: '10' }} />
            </ContainerField>
            <ContainerField layout={{ type: 'hbox', pack: 'start', wrap: true }} style={{ padding: 0, fontSize: '18px' }} >
              <RadioField name="MealOrderStatus" boxLabel="订餐" checked={MealOrderStatus == '订餐'} disabled={!bSave} onCheck={this.handleChange} style={{ padding: 0, fontSize: '18px' }} />
              <RadioField name="MealOrderStatus" boxLabel="不订餐" checked={MealOrderStatus == '不订餐'} disabled={!bSave} onCheck={this.handleChange} style={{ padding: 0, fontSize: '18px' }} />
            </ContainerField>
            <ContainerField layout={{ type: 'hbox', pack: 'start', wrap: true }} state={{ padding: 0, fontSize: '18px' }} >
              <Button ui="" text="确定" handler={() => this.onSave()} disabled={!bSave} />
              <Button ui="" text="取消" handler={() => this.onBack()} />
            </ContainerField>
          </Container>
        </Toolbar>
      </Container>
    )
  }
}

export default OrderingDetail